import { render } from "./productsPatternList.vue?vue&type=template&id=abcb60c2"
import script from "./productsPatternList.vue?vue&type=script&lang=js"
export * from "./productsPatternList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__